import { Card, CardContent, CardBody, CardTitle, } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState } from 'react';
import { useOrderDetailsContext, usePTCDocumentsContext, } from '../../../hooks/useContexts';
import { GetSelectedBectranDocumentAPI } from '../../../api/oms/order-details';
import { PTCDocumentCardSkeleton } from './PTCSkeletons';
/**
 * @returns PTC Document Card
 * @description This component is used to display the PTC Document Card that shows the
 * document title, created date, and the action to download.
 */
export var PTCDocumentCard = function (_a) {
    var pdfTitle = _a.pdfTitle, documentType = _a.documentType;
    var svocID = useThdCustomer().svocID;
    var orderDetailsData = useOrderDetailsContext().orderDetailsData;
    var _b = usePTCDocumentsContext(), setSelectedDocument = _b.setSelectedDocument, setDocumentLoadingError = _b.setDocumentLoadingError;
    var _c = useState(false), isDocumentLoading = _c[0], setIsDocumentLoading = _c[1];
    var _d = orderDetailsData || {}, purchaserId = _d.purchaserId, orderNumber = _d.orderNumber, orderNumbers = _d.orderNumbers;
    var orderNumberToUse = orderNumber || (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || '';
    // Remove the .pdf extension from the title
    var formattedTitle = pdfTitle.replace(/\.pdf$/i, '');
    // // Placeholder for created date
    // const createdDate = '2023-10-01T12:00:00Z';
    // // Format the date to be like "October 1, 2023"
    // const formattedDate = new Date(createdDate).toLocaleDateString(
    //   'en-US',
    //   { year: 'numeric', month: 'long', day: 'numeric' },
    // );
    var formattedDocumentType = {
        Invoice: 'INVOICE',
        'Credit Memo': 'RETURN',
        Adjustment: 'ADJUSTMENT',
    };
    var documentRequest = {
        invoiceFileRequest: {
            customerAccountId: svocID,
            purchaserId: purchaserId || '',
            orderNumber: orderNumberToUse,
            invoiceType: formattedDocumentType[documentType],
            fileName: pdfTitle,
        },
    };
    var requestDocumentOnClick = function () {
        setIsDocumentLoading(true);
        GetSelectedBectranDocumentAPI(documentRequest)
            .then(function (response) {
            if (response === null || response === void 0 ? void 0 : response.data) {
                setSelectedDocument({
                    pdfName: pdfTitle,
                    blob: response.data,
                    documentType: documentType,
                });
            }
        })
            .catch(function () {
            setDocumentLoadingError(true);
        })
            .finally(function () {
            setIsDocumentLoading(false);
        });
    };
    if (isDocumentLoading) {
        return (React.createElement(Card, { className: "sui-w-full" },
            React.createElement(CardBody, null,
                React.createElement(PTCDocumentCardSkeleton, null))));
    }
    return (React.createElement(Card, { className: "sui-w-full sui-rounded-md", onClick: function () { return requestDocumentOnClick(); } },
        React.createElement(CardContent, { disablePadding: true, className: "sui-flex sui-flex-col" },
            React.createElement("div", { className: "sui-flex sui-justify-between" },
                React.createElement(CardTitle, { headerVariant: "h5", header: formattedTitle, headerWeight: "bold" }),
                React.createElement(ArrowForward, { size: "regular" })),
            React.createElement(CardBody, null))));
};
